import {
  mobileOnlyLinaria,
  RowSection,
  SkeletonBlock,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  spotlightSliderAmbientHeightCSS,
  spotlightSliderHeightCSS,
} from '../../../features/SpotlightSlider/utils';

export const SpotlightSkeleton: React.FC = () => {
  return <StyledSkeletonBlock disableSpaceBelow />;
};

const StyledSkeletonBlock = styled(SkeletonBlock)`
  ${spotlightSliderAmbientHeightCSS};
  // genders height + slider margins
  --extra-margins: calc(32px + 24px);
  --slider-height-and-margins: calc(
    var(--slider-height) + var(--extra-margins)
  );
  height: var(--slider-height-and-margins);

  ${tabletAndUpLinaria(`
    ${spotlightSliderHeightCSS}
    
    --extra-margins: 0;
  `)};
`;

export const StreamSkeletons: React.FC = () => {
  return (
    <StreamSkeletonsWrapper>
      {/* skeleton for hero brand slider */}
      <TitleWrapper>
        <SkeletonBlock $width="100px" $height="30px" disableSpaceBelow />
        <SkeletonBlock $width="200px" $height="30px" />
        <SkeletonBlock $height="50vh" />
      </TitleWrapper>
      {/* generic section skeletons */}
      {Array.from({length: 4}).map((_, index) => (
        <div key={index}>
          <TitleWrapper>
            <SkeletonBlock $width="100px" $height="30px" disableSpaceBelow />
            <SkeletonBlock $width="200px" $height="30px" />
          </TitleWrapper>
          <Blocks>
            {Array.from({length: 4}).map((_, index) => (
              <SkeletonBlock key={index} $width="100%" $height="30vh" />
            ))}
          </Blocks>
        </div>
      ))}
    </StreamSkeletonsWrapper>
  );
};

const StreamSkeletonsWrapper = styled(RowSection)`
  display: flex;
  flex-direction: column;
  gap: 10vh;

  ${mobileOnlyLinaria(`
    gap: 6vh;
    width: calc(100% - 32px);
    margin-left: 16px;
  `)}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

const Blocks = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  ${tabletAndUpLinaria(`
    grid-template-columns: repeat(4, 1fr);
  `)}
`;
